<template>
  <section class="text-gray-400 body-font bg-gray-900">
    <div class="container px-5 py-24 mx-auto">
      <div class="flex flex-wrap w-full mb-20">
        <div class="lg:w-1/2 w-full mb-6 lg:mb-0">
          <h1 class="sm:text-3xl text-2xl font-medium title-font mb-2 text-white">Pitchfork Kickstarter Taxidermy</h1>
          <div class="h-1 w-20 bg-green-500 rounded-sm"></div>
        </div>
        <p class="lg:w-1/2 w-full leading-relaxed text-gray-400 text-opacity-90">Whatever cardigan tote bag tumblr hexagon brooklyn asymmetrical gentrify, subway tile poke farm-to-table. Franzen you probably haven't heard of them man bun deep jianbing selfies heirloom prism food truck ugh squid celiac humblebrag.</p>
      </div>
      <div class="flex flex-wrap -m-4">
        <div class="xl:w-1/4 md:w-1/2 p-4">
          <div class="bg-gray-800 bg-opacity-40 p-6 rounded-lg">
            <img class="h-40 rounded-sm w-full object-cover object-center mb-6" src="https://dummyimage.com/720x400" alt="content">
            <p class="tracking-widest text-green-400 text-xs font-medium title-font">SUBTITLE</p>
            <p class="text-lg text-white font-medium title-font mb-4">Chichen Itza</p>
            <p class="leading-relaxed text-base">Fingerstache flexitarian street art 8-bit waistcoat. Distillery hexagon disrupt edison bulbche.</p>
          </div>
        </div>
        <div class="xl:w-1/4 md:w-1/2 p-4">
          <div class="bg-gray-800 bg-opacity-40 p-6 rounded-lg">
            <img class="h-40 rounded-sm w-full object-cover object-center mb-6" src="https://dummyimage.com/721x401" alt="content">
            <p class="tracking-widest text-green-400 text-xs font-medium title-font">SUBTITLE</p>
            <p class="text-lg text-white font-medium title-font mb-4">Colosseum Roma</p>
            <p class="leading-relaxed text-base">Fingerstache flexitarian street art 8-bit waistcoat. Distillery hexagon disrupt edison bulbche.</p>
          </div>
        </div>
        <div class="xl:w-1/4 md:w-1/2 p-4">
          <div class="bg-gray-800 bg-opacity-40 p-6 rounded-lg">
            <img class="h-40 rounded-sm w-full object-cover object-center mb-6" src="https://dummyimage.com/722x402" alt="content">
            <p class="tracking-widest text-green-400 text-xs font-medium title-font">SUBTITLE</p>
            <p class="text-lg text-white font-medium title-font mb-4">Great Pyramid of Giza</p>
            <p class="leading-relaxed text-base">Fingerstache flexitarian street art 8-bit waistcoat. Distillery hexagon disrupt edison bulbche.</p>
          </div>
        </div>
        <div class="xl:w-1/4 md:w-1/2 p-4">
          <div class="bg-gray-800 bg-opacity-40 p-6 rounded-lg">
            <img class="h-40 rounded-sm w-full object-cover object-center mb-6" src="https://dummyimage.com/723x403" alt="content">
            <p class="tracking-widest text-green-400 text-xs font-medium title-font">SUBTITLE</p>
            <p class="text-lg text-white font-medium title-font mb-4">San Francisco</p>
            <p class="leading-relaxed text-base">Fingerstache flexitarian street art 8-bit waistcoat. Distillery hexagon disrupt edison bulbche.</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
